module.exports = __webpack_public_path__ + "static/media/bg_XC.75af73d2.jpg";